import { useEffect, useState } from "react";

interface Props {
  label?: string;
  id: string;
  defaultValue?: boolean;
  handleCheckedChange: any;
  paddingLeft?: any;
  disabled?: boolean;
}

const CheckBox = (props: Props) => {
  const [checked, setChecked] = useState(props.defaultValue);

  useEffect(() => {
    setChecked(props.defaultValue);
  }, [props.defaultValue])

  return (
    <div className="row" style={{ paddingLeft: props.paddingLeft ?? "150px" }}>
      <div className="form-check form-switch">
        {props.label && (
          <label className="form-check-label" htmlFor={props.id}>
            {props.label}
          </label>
        )}
        <input
          onClick={() => {
            setChecked(!checked);
            props.handleCheckedChange(!checked);
          }}
          className="form-check-input"
          type="checkbox"
          id={props.id}
          checked={checked}
          {...(props.disabled ? { disabled: true } : {})}
        />
      </div>
    </div>
  );
};

export default CheckBox;
